import React from 'react';
import { Link } from 'react-router-dom';
import './IntechsanteCarouselSlide.css';

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);

const IntechsanteCarouselSlide = () => (
  <div className="intechsante-carousel-slide" role="img" aria-label="Vardaan at INTECHSANTÉ Medical Expo 2026">
    <div className="intechsante-carousel-mesh" aria-hidden="true">
      <svg viewBox="0 0 1600 700" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="intechsante-dots" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="rgba(255,255,255,0.18)" />
          </pattern>
          <pattern id="intechsante-mesh-pattern" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse">
            <line x1="0" y1="0" x2="120" y2="120" stroke="rgba(31, 142, 142, 0.08)" strokeWidth="0.5" />
            <line x1="120" y1="0" x2="0" y2="120" stroke="rgba(31, 142, 142, 0.08)" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#intechsante-dots)" />
        <rect width="100%" height="100%" fill="url(#intechsante-mesh-pattern)" />
        <g stroke="rgba(31, 142, 142, 0.3)" strokeWidth="0.7" fill="none">
          <path d="M 1200 100 L 1350 180 L 1500 140 L 1550 220 L 1480 320 L 1380 280 L 1200 100 Z" />
          <path d="M 1350 180 L 1450 380 L 1380 280" />
          <path d="M 1500 140 L 1480 320" />
          <path d="M 1350 380 L 1450 380 L 1550 460 L 1480 320" />
        </g>
        <g fill="rgba(255,255,255,0.7)">
          <circle cx="1200" cy="100" r="2.5" />
          <circle cx="1350" cy="180" r="2.5" />
          <circle cx="1500" cy="140" r="2.5" />
          <circle cx="1550" cy="220" r="2.5" />
          <circle cx="1480" cy="320" r="2.5" />
          <circle cx="1380" cy="280" r="2.5" />
          <circle cx="1450" cy="380" r="2.5" />
          <circle cx="1550" cy="460" r="2.5" />
        </g>
        <g stroke="rgba(45, 95, 63, 0.28)" strokeWidth="0.7" fill="none">
          <path d="M 60 200 L 180 280 L 120 400 L 220 480" />
          <path d="M 180 280 L 280 220" />
          <path d="M 220 480 L 320 540" />
        </g>
        <g fill="rgba(255,255,255,0.6)">
          <circle cx="60" cy="200" r="2.2" />
          <circle cx="180" cy="280" r="2.2" />
          <circle cx="280" cy="220" r="2.2" />
          <circle cx="120" cy="400" r="2.2" />
          <circle cx="220" cy="480" r="2.2" />
          <circle cx="320" cy="540" r="2.2" />
        </g>
      </svg>
    </div>

    <div className="intechsante-carousel-glow-left" aria-hidden="true" />
    <div className="intechsante-carousel-glow-right" aria-hidden="true" />

    <div className="intechsante-carousel-stamp">
      <span><span className="intechsante-carousel-accent">●</span>&nbsp;&nbsp;Vardaan Newsroom</span>
      <span>Panel Appearance</span>
    </div>

    <div className="intechsante-carousel-date">
      <span>Friday</span>
      <span className="intechsante-carousel-date-big">19 June 2026</span>
    </div>

    <div className="intechsante-carousel-content">
      <div className="intechsante-carousel-eyebrow">Vardaan at</div>

      <h2 className="intechsante-carousel-headline">
        INTECHSANTÉ <em>Medical Expo</em> 2026
      </h2>

      <div className="intechsante-carousel-event-card">
        <div className="intechsante-carousel-event-mark" aria-hidden="true" />
        <div className="intechsante-carousel-event-text">
          <div className="intechsante-carousel-event-name">Forum INTECHSANTÉ</div>
          <div className="intechsante-carousel-event-sub">Côte d&apos;Ivoire · 2<sup>e</sup> Édition</div>
        </div>
      </div>

      <p className="intechsante-carousel-tagline">
        Our CEO joins the panel on Interoperability and Technical Standards — shaping the foundation of an integrated African digital health ecosystem.
      </p>

      <Link to="/newsroom/intechsante" className="intechsante-carousel-cta" onClick={(e) => e.stopPropagation()}>
        Read More
        <ArrowIcon />
      </Link>
    </div>

    <div className="intechsante-carousel-signature">
      <span className="intechsante-carousel-brand">Vardaan</span> &nbsp;·&nbsp; Data Sciences
    </div>

    <div className="intechsante-carousel-location">
      Abidjan, Côte d&apos;Ivoire<br />
      10:00 — 11:30 · Salle 2
    </div>
  </div>
);

export default IntechsanteCarouselSlide;
